// DatePickerComponent.jsx
import { Controller, useFormContext } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';

const RHFdatePicker = ({ name, disabled = false }) => {
    const { control} = useFormContext();
  
    return (
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            // className='date-picker'
            disabled={disabled}
            slotProps={{
              textField: {
                fullWidth: true,
                variant: 'outlined',
                error: !!error,
                helperText: error?.message,
                style: { height: '40px !important',
                 }, // Adjust the height here
              },
            }}
            {...field}
          />
        )}
      />
    );
  };
  

export default RHFdatePicker;
